const translations = {
  'nav.about': 'За нас',
  'nav.packages': 'Тарифи',
  'nav.calculator': 'Калкулатор',
  'nav.contacts': 'Контакти',
  'nav.cta': 'Започни инвестиране',

  'hero.badge': 'Сезонен тренд · Пролет 2025',
  'hero.title_p1': 'Пролетният ръст на',
  'hero.title_hl': 'царевицата',
  'hero.title_p2': '— възможност за печалба от сезонния тренд',
  'hero.desc': 'Исторически цената на царевицата расте през пролетта поради увеличеното търсене от производители на фуражи, биоетанол и подготовка на аграрния сезон. Инвеститорите използват този сезонен цикъл всяка година.',
  'hero.cta1': 'Изчисли печалбата сега',
  'hero.cta2': 'Виж тарифите',
  'hero.stat1.val': '+34%',
  'hero.stat1.label': 'Среден пролетен ръст',
  'hero.stat2.val': '5+ години',
  'hero.stat2.label': 'Стабилен тренд',
  'hero.stat3.val': 'ТОП-3',
  'hero.stat3.label': 'Световен агро актив',
  'hero.scroll': 'превъртете надолу',
  'hero.chart.title': 'Динамика на Corn · Пролет',
  'hero.chart.subtitle': 'Индексиран ръст (Фев = 100%)',
  'hero.chart.maxgrowth': '+38%',
  'hero.chart.maxlabel': 'Максимален сезонен ръст',
  'hero.chart.years': '100%',
  'hero.chart.yearslabel': 'Години с положителен ръст',
  'hero.months.0': 'Фев',
  'hero.months.1': 'Мар',
  'hero.months.2': 'Апр',
  'hero.months.3': 'Май',

  'price.badge': 'Сезонна аналитика',
  'price.title_p1': 'Защо царевицата',
  'price.title_hl': 'расте през пролетта?',
  'price.subtitle': 'Пет ключови фактора, формиращи стабилен ценови тренд всяка година',
  'price.r1.title': 'Търсене от животновъдство',
  'price.r1.desc': 'През пролетта търсенето на фуражи нараства от животновъдни предприятия, подготвящи се за активния сезон.',
  'price.r1.statLabel': 'ръст на търсенето',
  'price.r2.title': 'Посевна кампания',
  'price.r2.desc': 'Началото на активния период на сеитба създава ажиотаж на пазара и натиск върху наличните запаси.',
  'price.r2.statLabel': 'ръст на активността',
  'price.r3.title': 'Производители на биоетанол',
  'price.r3.desc': 'Биоетанолните заводи увеличават покупките на царевица за производство на гориво през пролетния сезон.',
  'price.r3.statLabel': 'ръст на покупките',
  'price.r4.title': 'Намаляване на запасите',
  'price.r4.desc': 'До пролетта запасите от миналата година намаляват, създавайки дефицит на предлагане и тласкайки цената нагоре.',
  'price.r4.statLabel': 'остатъци от запаси',
  'price.r5.title': 'Пазарни очаквания',
  'price.r5.desc': 'Пазарът отчита очакванията за бъдещата реколта — несигурността увеличава волатилността и потенциала за ръст.',
  'price.r5.statLabel': 'ръст на волатилността',
  'price.banner.avg': 'Среден ръст за 5 години',
  'price.banner.desc': 'Според статистиката от предишните години пролетният сезон е един от най-активните периоди на ръст на цената на',
  'price.banner.corn': 'Corn',
  'price.banner.desc2': '.',
  'price.banner.disclaimer': 'Исторически данни CME Group, USDA · не е финансов съвет',
  'price.banner.years': 'Години с ръст (5/5)',

  'pkg.badge': 'Инвестиционни контракти',
  'pkg.title_p1': 'Изберете вашия',
  'pkg.title_hl': 'инвестиционен',
  'pkg.title_p2': 'контракт',
  'pkg.subtitle': 'Три нива на участие — от старт до максимална печалба',
  'pkg.start.name': 'Контракт Старт',
  'pkg.balance.name': 'Контракт Баланс',
  'pkg.premium.name': 'Контракт Премиум',
  'pkg.seasonal': 'Инвестиции в Corn · 2 дни',
  'pkg.investment': 'Инвестиция',
  'pkg.duration': 'Срок:',
  'pkg.days': 'дни',
  'pkg.yield': 'Доходност',
  'pkg.profit': 'Печалба:',
  'pkg.cta': 'Започни инвестиране',
  'pkg.popular': 'Популярен',
  'pkg.max': 'Максимум',
  'pkg.disclaimer': '* Всички данни за доходността се основават на историческата пазарна динамика. Инвестициите са свързани с рискове.',
  'pkg.f.threshold': 'Входен праг — €{{amount}}',
  'pkg.f.profit': 'Печалба {{pct}}% за 2 дни',
  'pkg.f.report.monthly': 'Месечен отчет',
  'pkg.f.report.weekly': 'Седмичен отчет',
  'pkg.f.report.daily': 'Дневен отчет',
  'pkg.f.support.reg': 'Поддръжка 5/7',
  'pkg.f.support.prio': 'Приоритетна поддръжка',
  'pkg.f.support.vip': 'VIP поддръжка 7/7',
  'pkg.f.account': 'Личен кабинет',
  'pkg.f.analytics': 'Пазарна аналитика',
  'pkg.f.manager': 'Личен мениджър',
  'pkg.duration_fixed': 'Фиксиран срок за всички контракти',

  'calc.badge': 'Калкулатор на доходността',
  'calc.title_p1': 'Изчислете',
  'calc.title_hl': 'вашата печалба',
  'calc.subtitle': 'Въведете параметрите и разберете очаквания доход',
  'calc.params': 'Параметри на инвестицията',
  'calc.amount': 'Сума на инвестицията',
  'calc.package': 'Инвестиционен пакет',
  'calc.dur.label': 'Срок на инвестицията',
  'calc.dur.val': '2 дни',
  'calc.dur.fixed': 'Фиксиран срок за всички контракти',
  'calc.result': 'Резултат от изчислението',
  'calc.expected': 'Очаквана печалба',
  'calc.per2days': '% за 2 дни',
  'calc.total': 'Обща сума',
  'calc.invested': 'Инвестиция',
  'calc.pkg.label': 'Тариф',
  'calc.period': 'Период',
  'calc.period.val': '2 дни',
  'calc.bar.invested': 'Вложено',
  'calc.bar.profit': 'Печалба',
  'calc.cta': 'Избери контракт',

  'activity.header': 'Активност на платформата',
  'activity.invested': 'инвестира',
  'activity.profit': 'получи печалба',
  'activity.just_now': 'току-що',
  'activity.1min': 'преди 1 мин.',
  'activity.2min': 'преди 2 мин.',
  'activity.3min': 'преди 3 мин.',
  'activity.disclaimer': 'демонстрация на активността на потребителите в реално време',
  'activity.badge': 'Общност от инвеститори',
  'activity.title_p1': 'Хиляди инвеститори вече',
  'activity.title_hl': 'печелят с нас',
  'activity.desc': 'Всеки ден нашите клиенти получават печалба от сезонния тренд на царевицата. Присъединете се към хилядите инвеститори, които използват този цикъл ежегодно.',
  'activity.stat1': 'Активни инвеститори',
  'activity.stat2': 'Средства под управление',
  'activity.stat3': 'Доволни клиенти',
  'activity.join': 'Присъединете се',
  'activity.view': 'Виж тарифите',

  'toast.earned': 'току-що спечели',

  'trust.badge': 'Защо ни се доверяват',
  'trust.title_p1': 'Надеждност, проверена от',
  'trust.title_hl': 'времето',
  'trust.subtitle': 'Corn е един от най-ликвидните и предсказуеми аграрни активи в света',
  'trust.item1.title': 'Най-старият инструмент за търговия',
  'trust.item1.desc': 'Инвестициите в аграрни суровинни пазари са един от най-старите инструменти за сезонна търговия — проверено от векове пазарна история.',
  'trust.item2.title': 'ТОП-3 световни аграрни активи',
  'trust.item2.desc': 'Corn е в топ-3 световни селскостопански активи по обем на търговия и ликвидност на борсите CME и CBOT.',
  'trust.item3.title': 'Повишена пролетна волатилност',
  'trust.item3.desc': 'Пролетният сезон исторически показва повишена волатилност и потенциал за ръст, създавайки уникални възможности за инвеститорите.',
  'trust.stat1.label': 'години история на пазара',
  'trust.stat2.label': 'годишен обем на търговия',
  'trust.stat3.label': 'сред аграрните активи',
  'trust.stat4.label': 'ликвидност на позициите',
  'trust.cta.desc': 'Готови ли сте да се възползвате от пролетния тренд? Изчислете потенциалната си печалба сега.',
  'trust.cta.btn': 'Изчисли печалбата сега',

  'footer.tagline': '— Сезонни инвестиции в Corn',
  'footer.about': 'За нас',
  'footer.packages': 'Тарифи',
  'footer.calculator': 'Калкулатор',
  'footer.disclaimer': '© 2025 CornVest. Не е инвестиционен съвет.',
};

export default translations;
